import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from "@/components/ui/dropdown-menu";
import { SlidersHorizontal, Search } from "lucide-react";

// cols: [{ key, label, align?, cell:(row)=>node, default?:bool }]
export function useActiveColumns(pageKey, cols) {
  const company = localStorage.getItem("vg_company") || "default";
  const storeKey = `vg_cols_${pageKey}_${company}`;
  const allKeys = cols.map((c) => c.key);
  const defaultKeys = cols.filter((c) => c.default !== false).map((c) => c.key);
  const [visible, setVisible] = useState(() => {
    try { const s = JSON.parse(localStorage.getItem(storeKey)); if (Array.isArray(s)) return s.filter((k) => allKeys.includes(k)); } catch (e) {}
    return defaultKeys;
  });
  useEffect(() => { localStorage.setItem(storeKey, JSON.stringify(visible)); }, [storeKey, visible]);
  const shown = cols.filter((c) => visible.includes(c.key));
  const Picker = <ColumnPicker cols={cols} visible={visible} setVisible={setVisible} />;
  return { shown, visible, setVisible, Picker };
}

export const alignClass = (a) => a === "right" ? "text-right" : a === "center" ? "text-center" : "text-left";

function ColumnPicker({ cols, visible, setVisible }) {
  const [q, setQ] = useState("");
  const filtered = cols.filter((c) => c.label.toLowerCase().includes(q.toLowerCase()));
  const allOn = visible.length === cols.length;
  const toggle = (k) => setVisible((v) => v.includes(k) ? v.filter((x) => x !== k) : [...v, k]);
  const toggleAll = () => setVisible(allOn ? [] : cols.map((c) => c.key));
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="columns" size="sm" data-testid="column-picker-btn"><SlidersHorizontal className="h-4 w-4 mr-1" /> Columns</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 p-2" onCloseAutoFocus={(e) => e.preventDefault()}>
        <div className="text-xs font-semibold px-1 pb-2">Active Columns</div>
        <div className="relative mb-2"><Search className="h-3.5 w-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search columns…" className="h-8 pl-8 text-sm" data-testid="column-search" /></div>
        <label className="flex items-center gap-2 px-1.5 py-1.5 rounded hover:bg-slate-50 cursor-pointer border-b mb-1 font-medium text-sm">
          <input type="checkbox" checked={allOn} onChange={toggleAll} className="h-4 w-4 accent-brand-600" data-testid="column-select-all" /> Select All
        </label>
        <div className="max-h-60 overflow-y-auto space-y-0.5">
          {filtered.map((c) => (
            <label key={c.key} className="flex items-center gap-2 px-1.5 py-1.5 rounded hover:bg-slate-50 cursor-pointer text-sm" data-testid={`column-opt-${c.key}`}>
              <input type="checkbox" checked={visible.includes(c.key)} onChange={() => toggle(c.key)} className="h-4 w-4 accent-brand-600" /> {c.label}
            </label>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
